
import { Component, Vue, Watch } from "vue-property-decorator";
import Sidebar from "@/components/navigations/Sidebar.vue";
import Cta from "@/components/buttons/Button.vue";
import Alert from "@/components/alert/Alert.vue";
import SwitchToggle from "@/components/switch/Switch.vue";
import PanelOption from "@/components/option/Option.vue";
import { User, UserCalendrier } from "@/models";
import { login, toast, profile } from "@/store";
import { TYPE } from "@/store/modules/toast.module";
import { LocalStorageApp } from "@/utils/localstorage";

@Component({
  components: {
    Sidebar,
    Cta,
    Alert,
    SwitchToggle,
    PanelOption,
  },
})
/** "Mon calendrier" — ICS subscription link + calendar notification preferences. */
export default class MonCalendrier extends Vue {
  private linkICS: string | null = null;

  private openEope(): void {
    window.open(
      "https://eope.protectioncivile.org",
      "_blank",
      "noopener,noreferrer"
    );
  }

  private optionCalendrier = false;

  private param_retenu = false;
  private param_prov = false;
  private param_cancel = false;
  private param_busy = false;

  mounted() {
    this.setLinkICS();
    this.getSettings();
  }

  /** Copies the ICS subscription link to the clipboard. */
  private copy() {
    if (this.linkICS) {
      this.$copyText(this.linkICS).then(
        function () {
          toast.createAndPushToast(
            "Copié !",
            "Le lien de votre calendrier a bien été copié",
            true,
            TYPE.DEFAULT
          );
        },
        function (e) {
          toast.pushError("Le lien n'a pas pu être copié");
          console.log(e);
        }
      );
    }
  }

  private openOption(): void {
    this.optionCalendrier = true;
  }

  private closeOption(): void {
    this.optionCalendrier = false;
  }

  /** Opens the wiki page about "Mon calendrier", passing the user's token for auto-login. */
  private openWiki(): void {
    const token = LocalStorageApp.getItem("pcp.token");
    window.open(
      `http://wiki.protectioncivile-paris8.org/index.php?title=Mon_calendrier_-_Timeline&token=${token}`,
      "_blank"
    );
  }

  /** Rebuilds the ICS subscription URL from the user's api_key whenever context loads/changes. */
  @Watch("context")
  private setLinkICS(): void {
    this.linkICS = `https://timeline.protectioncivile-paris8.org/api/ics/?key=${this.context?.api_key}`;
  }

  /** Syncs local form fields from the user's saved calendar preferences whenever context loads/changes. */
  @Watch("context")
  private getSettings(): void {
    if (this.context) {
      this.param_retenu = this.context.preferences.calendrier.retenu;
      this.param_prov = this.context.preferences.calendrier.provisoire;
      this.param_cancel = this.context.preferences.calendrier.cancel;
      this.param_busy = this.context.preferences.calendrier.busy;
    }
  }

  /** Persists the calendar preference form fields. */
  private setSettings(): void {
    if (this.context) {
      profile.updateParamCalendrier({
        retenu: this.param_retenu,
        provisoire: this.param_prov,
        cancel: this.param_cancel,
        busy: this.param_busy,
      } as UserCalendrier);
    }
  }

  get context(): User | null {
    return login.getContext;
  }
}
